<template>
  <div class="contract-parent">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'ContractMainContainer',
  components: { },
  data () {
    return {}
  },
  methods: {}
}
</script>
